import { Eye } from "@hl/base-components/lib/assets/icons/HDS/";
import { CLEAR_COLOR } from "@hl/base-components/lib/theme/button";
import { ResizedImage } from "@hl/shared-features/lib/features/image";
import { Button, Flex, Group, Stack, Text, Title } from "@mantine/core";
import useMantineMediaQueries from "~/../../base-components/lib/hooks/useMantineMediaQueries";

import { _CollectionType } from "apollo/graphql.generated";
import { MINT_BASE_URL } from "config";
import { BlockchainEntity } from "~/components/BlockchainEntityTitle/types";
import { collectionTypeToDisplayName } from "~/features/collections/displayUtils";
import ManageTokenHeaderButtons from "~/features/tokens/sections/ManageToken/ManageTokenHeaderButtons";

interface BlockchainEntityTitleProps {
  blockchainEntity: BlockchainEntity;
}

const ManageTokenHeader = ({
  blockchainEntity,
}: BlockchainEntityTitleProps) => {
  const { details, networkData } = blockchainEntity;
  const { isMedium } = useMantineMediaQueries();

  const size = blockchainEntity.mintStatus?.total;

  const mintUrl = MINT_BASE_URL + `/${blockchainEntity.id}`;

  return (
    <Stack spacing={20}>
      <Group position="apart" noWrap>
        <Flex
          direction={{ base: "column", md: "row" }}
          gap={{ base: "lg" }}
          w="100%"
        >
          <ResizedImage
            src={details.image}
            fit="contain"
            radius={0}
            width={isMedium ? 112 : "100%"}
            height={isMedium ? 112 : 312}
          />
          <Stack spacing={4}>
            <Title order={3}>{details.name}</Title>
            <Text size="sm">
              <Group spacing={8}>
                <span>
                  {collectionTypeToDisplayName(
                    blockchainEntity.collectionType
                  ) ?? blockchainEntity.entityType}
                </span>
                {networkData && (
                  <>
                    <span>·</span>
                    <span>{networkData.displayName}</span>
                  </>
                )}
                <span>·</span>
                <span>{blockchainEntity.contractType}</span>
                {size &&
                  blockchainEntity.collectionType !==
                    _CollectionType.OneOfOne && (
                    <>
                      <span>·</span>
                      <span>
                        {size} token{size > 1 ? "s" : ""}
                      </span>
                    </>
                  )}
              </Group>
            </Text>
          </Stack>
        </Flex>
        {isMedium && (
          <Button
            component="a"
            color={CLEAR_COLOR}
            rightIcon={<Eye />}
            target="_blank"
            href={mintUrl}
          >
            View mint page
          </Button>
        )}
      </Group>
      <ManageTokenHeaderButtons blockchainEntity={blockchainEntity} />
    </Stack>
  );
};

export default ManageTokenHeader;
